import { Action, createReducer, on } from '@ngrx/store';

import {
	fetchAllOrgUsersSuccess,
	fetchAllPermissionsSuccess,
	fetchBeneOnlyFailure,
	fetchBeneOnlyStart,
	fetchBeneOnlySuccess,
	fetchGroupsSuccess,
	fetchUsersSuccess,
	updateUsersSuccess,
	promoteBeneToAdminStart,
	promoteBeneToAdminSuccess,
	promoteBeneToAdminFailure,
} from './groups.actions';
import { initialState } from './groups.state';

const groupsReducer = createReducer(
	initialState,
	on(fetchGroupsSuccess, (state, action) => ({
		...state,
		groups: action.groups,
	})),
	// on(fetchGroupsFailure, (state, action) => ({ ...state })),
	on(fetchUsersSuccess, (state, action) => ({
		...state,
		groupUsers: action.groupUsers,
	})),
	// on(fetchUsersFailure, (state, action) => ({ ...state })),
	on(fetchAllOrgUsersSuccess, (state, action) => ({
		...state,
		users: action.users,
	})),
	on(fetchAllPermissionsSuccess, (state, action) => ({
		...state,
		groupPermissions: action.groupPermissions,
		permissions: action.permissions,
	})),
	// on(fetchPermissionsFailure, (state, action) => ({ ...state })),

	on(updateUsersSuccess, (state) => ({ ...state })),

	on(fetchBeneOnlyStart, (state) => ({
		...state,
		beneOnlyUsers: [],
		loading: true,
	})),
	on(fetchBeneOnlySuccess, (state, action) => ({
		...state,
		beneOnlyUsers: action.beneUsers,
		loading: false,
	})),
	on(fetchBeneOnlyFailure, (state) => ({ ...state, loading: false })),

	on(promoteBeneToAdminStart, (state) => ({ ...state, loading: true })),
	on(promoteBeneToAdminSuccess, (state) => ({
		...state,
		loading: false,
	})),
	on(promoteBeneToAdminFailure, (state) => ({ ...state, loading: false })),
);

export function GroupsReducer(state: any, action: Action) {
	return groupsReducer(state, action);
}
